import { useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  ChevronIcon,
  InstagramIcon,
  FacebookIcon,
  LogoSm,
} from "../assets/global/Icons";
import "./MobileNav.scss";
import "./MainNav.scss";
import { SERVICES_ENABLED } from "../common/constants";

function MobileNav() {
  const [isMenuDropdownOpen, setIsMenuDropdownOpen] = useState(false);
  const [isServicesDropdownOpen, setIsServicesDropdownOpen] = useState(false);
  const location = useLocation();
  const navCheckboxRef = useRef<HTMLInputElement>(null);

  function handleMenuDropdownToggle() {
    setIsMenuDropdownOpen((prev) => !prev);
  }

  function handleServicesDropdownToggle() {
    setIsServicesDropdownOpen((prev) => !prev);
  }

  function handleCloseMobileNav() {
    setIsMenuDropdownOpen(false);
    setIsServicesDropdownOpen(false);

    if (navCheckboxRef.current) {
      navCheckboxRef.current.checked = false;
    }
  }

  return (
    <nav className="mobile-nav" role="navigation">
      <input
        type="checkbox"
        className="mobile-nav__checkbox"
        ref={navCheckboxRef}
      />
      <div className="mobile-nav__hamburger">
        <span className="hamburger"></span>
        <span className="hamburger"></span>
        <span className="hamburger"></span>
      </div>
      <ul className="mobile-nav__list">
        <Link to="/" onClick={handleCloseMobileNav}>
          <LogoSm className="mobile-nav__logo" />
        </Link>
        <li>
          <Link
            to="/"
            className={`mobile-nav__link ${location.pathname === "/" ? "active" : ""}`}
            onClick={handleCloseMobileNav}
          >
            home
          </Link>
        </li>
        <li>
          <Link
            to="/menu"
            className={`mobile-nav__link ${location.pathname.startsWith("/menu") ? "active" : ""}`}
            onClick={handleCloseMobileNav}
          >
            menu
          </Link>
          <button
            type="button"
            className={`mobile-nav__dropdown-toggle ${isMenuDropdownOpen ? "open" : ""}`}
            onClick={handleMenuDropdownToggle}
            aria-expanded={isMenuDropdownOpen}
            aria-controls="mobile-menu-nav-dropdown"
            aria-label="View menu selections"
          >
            <ChevronIcon className="chevron-icon" />
          </button>
          <ul
            className={`dropdown-nav mobile-dropdown-nav ${isMenuDropdownOpen ? "open" : ""}`}
            id="mobile-menu-nav-dropdown"
          >
            <li>
              <Link
                to="/menu/cakes"
                className="dropdown-nav__link"
                onClick={handleCloseMobileNav}
              >
                cakes
              </Link>
            </li>
            <li>
              <Link
                to="/menu/cupcakes"
                className="dropdown-nav__link"
                onClick={handleCloseMobileNav}
              >
                cupcakes
              </Link>
            </li>
            <li>
              <Link
                to="/menu/cookies"
                className="dropdown-nav__link"
                onClick={handleCloseMobileNav}
              >
                cookies
              </Link>
            </li>
            <li>
              <Link
                to="/menu/cakesicles"
                className="dropdown-nav__link"
                onClick={handleCloseMobileNav}
              >
                cakesicles
              </Link>
            </li>
            <li>
              <Link
                to="/menu/tarts-bars-brownies"
                className="dropdown-nav__link"
                onClick={handleCloseMobileNav}
              >
                tarts, bars, brownies
              </Link>
            </li>
          </ul>
        </li>
        {SERVICES_ENABLED && (
          <li>
            <Link
              to="/services"
              className={`mobile-nav__link ${location.pathname.startsWith("/services") ? "active" : ""}`}
              onClick={handleCloseMobileNav}
            >
              services
            </Link>
            <button
              type="button"
              className={`mobile-nav__dropdown-toggle ${isServicesDropdownOpen ? "open" : ""}`}
              onClick={handleServicesDropdownToggle}
              aria-expanded={isServicesDropdownOpen}
              aria-controls="mobile-services-nav-dropdown"
              aria-label="View services selections"
            >
              <ChevronIcon className="chevron-icon" />
            </button>
            <ul
              className={`dropdown-nav mobile-dropdown-nav ${isServicesDropdownOpen ? "open" : ""}`}
              id="mobile-services-nav-dropdown"
            >
              <li>
                <Link
                  to="/services/private-events"
                  className="dropdown-nav__link"
                  onClick={handleCloseMobileNav}
                >
                  private events
                </Link>
              </li>
              <li>
                <Link
                  to="/services/corporate-events"
                  className="dropdown-nav__link"
                  onClick={handleCloseMobileNav}
                >
                  corporate events
                </Link>
              </li>
              <li>
                <Link
                  to="/services/weddings"
                  className="dropdown-nav__link"
                  onClick={handleCloseMobileNav}
                >
                  weddings
                </Link>
              </li>
              <li>
                <Link
                  to="/services/holiday-orders"
                  className="dropdown-nav__link"
                  onClick={handleCloseMobileNav}
                >
                  holiday orders
                </Link>
              </li>
              <li>
                <Link
                  to="/services/equipment-rental"
                  className="dropdown-nav__link"
                  onClick={handleCloseMobileNav}
                >
                  equipment rental
                </Link>
              </li>
            </ul>
          </li>
        )}
        <li>
          <Link
            to="/classes"
            className="mobile-nav__link"
            onClick={handleCloseMobileNav}
          >
            classes
          </Link>
        </li>
        <li>
          <Link
            to="/gallery"
            className="mobile-nav__link"
            onClick={handleCloseMobileNav}
          >
            gallery
          </Link>
        </li>
        <li>
          <Link
            to="/about"
            className="mobile-nav__link"
            onClick={handleCloseMobileNav}
          >
            about
          </Link>
        </li>
        <li>
          <Link
            to="/order"
            className="mobile-nav__link"
            id="order-nav"
            onClick={handleCloseMobileNav}
          >
            order
          </Link>
        </li>
        <hr className="nav-hr" />
        <li>
          <Link
            to="/faqs"
            className="mobile-nav__link"
            onClick={handleCloseMobileNav}
          >
            faqs
          </Link>
        </li>
        <div className="mobile-nav__socials">
          <a
            href="https://www.instagram.com/conniescakerie"
            target="_blank"
            rel="noopener noreferrer"
          >
            <InstagramIcon
              className="social-icon-mobile"
              role="button"
              aria-label="Follow us on Instagram"
            />
          </a>
          <a
            href="https://www.facebook.com/conniescakerie"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FacebookIcon
              className="social-icon-mobile"
              role="button"
              aria-label="Like our Facebook page"
            />
          </a>
        </div>
      </ul>
    </nav>
  );
}

export default MobileNav;
